import React from "react";
import { Formik } from "formik";
import Select from "react-select";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { CreateTaskSchema } from "../../auth/Schema";
import ErrorMessage from "../ErrorMessage";

const AssignTechnicianModal = ({
  modalId = "ct_generate_invoice",
  title = "Create A Maintenance Task",
  subtitle = "Choose user and schedule the job for execution.",
  initialValues,
  onSubmit,
  allBoats = [],
  selectedTaskId,

  staffActiveData = [],
  staffDropdownData = [],
}) => {
  const today = new Date()?.toISOString()?.split("T")[0];
  console.log("staffDropdownData", staffDropdownData);
  return (
    <div
      className="modal fade"
      id={modalId}
      tabIndex={-1}
      aria-labelledby={`${modalId}Label`}
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content ct_border_radius_20">
          <div className="modal-body">
            <div className="ct_delete_post_modal p-4">
              <figure className="mb-0">
                <figcaption>
                  <div className="d-flex justify-content-between align-items-start gap-3">
                    <div>
                      <h4
                        className="ct_fs_24 ct_fw_600 ct_blue_text mb-2"
                        id={`${modalId}Label`}
                      >
                        {title}
                      </h4>
                      <p className="mb-0 ct_text_para ct_fs_16">{subtitle}</p>
                    </div>
                    <div data-bs-dismiss="modal" className="ct_pointer">
                      <i className="fa-solid fa-xmark"></i>
                    </div>
                  </div>
                </figcaption>

                <Formik
                  initialValues={initialValues}
                  validationSchema={CreateTaskSchema}
                  onSubmit={(values, actions) => {
                    onSubmit(
                      {
                        ...values,
                        taskId: selectedTaskId
                      },
                      actions,
                    );
                  }}
                  enableReinitialize
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    resetForm,
                    setFieldValue,
                  }) => (
                    <form className="mt-5">
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form-group mb-3">
                            <label className="form-label">
                              Assign To
                              <span className="ct_required_star">*</span>
                            </label>
                            <select
                              id="assignStaffId"
                              className="form-control ct_input ct_transparent_input ct_pointer_curser"
                              value={values?.assignStaffId}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue(
                                  "supplierId",
                                  e.target.value === "OUTSOURCED" ? [] : "",
                                );
                              }}
                            >
                              <option value="">Select assignment type</option>
                              <option value="STAFF">Internal Staff</option>
                              <option value="OUTSOURCED">Out Source</option>
                            </select>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="assignStaffId"
                            />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form-group mb-3">
                            <label className="form-label">
                              {values?.assignStaffId === "OUTSOURCED"
                                ? "Select Supplier"
                                : "Select Technician"}
                              {values?.assignStaffId && (
                                <span className="ct_required_star">*</span>
                              )}
                            </label>
                            {values?.assignStaffId === "OUTSOURCED" ? (
                              <>
                                <Select
                                  options={staffDropdownData}
                                  isMulti
                                  placeholder="Select users"
                                  value={values?.supplierId}
                                  onChange={(selected) => {
                                    const isSelectAllSelected = selected?.some(
                                      (option) => option.value === "all",
                                    );

                                    if (isSelectAllSelected) {
                                      setFieldValue(
                                        "supplierId",
                                        staffDropdownData.filter(
                                          (option) => option.value !== "all",
                                        ),
                                      );
                                      return;
                                    }

                                    setFieldValue("supplierId", selected);
                                  }}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="supplierId"
                                />
                              </>
                            ) : (
                              <>
                                <select
                                  id="supplierId"
                                  className="form-control ct_input ct_transparent_input ct_pointer_curser"
                                  value={values?.supplierId}
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  disabled={values?.assignStaffId !== "STAFF"}
                                >
                                  <option value="">
                                    {values?.assignStaffId === "STAFF"
                                      ? "Select technician"
                                      : "Select assign to first"}
                                  </option>
                                  {staffActiveData?.map((item) => (
                                    <option key={item?.id} value={item?.id}>
                                      {item?.full_name ?? ""} -{" "}
                                      {item?.role ?? ""}
                                    </option>
                                  ))}
                                </select>
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="supplierId"
                                />
                              </>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form-group mb-3">
                            <label className="form-label">
                              Time Allocated(Hours)
                              <span className="ct_required_star">*</span>
                            </label>
                            <input
                              type="number"
                              id="time_alloted"
                              placeholder="00 hrs"
                              className="form-control ct_input ct_transparent_input"
                              value={values?.time_alloted}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              onWheel={() => document.activeElement.blur()}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="time_alloted"
                            />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form-group mb-3">
                            <label className="form-label">
                              Quoted Value
                              <span className="ct_required_star">*</span>
                            </label>
                            <div className="position-relative">
                              <input
                                type="number"
                                id="quoted_value"
                                className="form-control ct_input ct_transparent_input ct_input_ps_40"
                                value={values?.quoted_value}
                                onBlur={handleBlur}
                                onChange={handleChange}
                                onWheel={() => document.activeElement.blur()}
                              />
                              <div className="ct_show_search">$</div>
                            </div>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="quoted_value"
                            />
                          </div>
                        </div>

                        {/* <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <label className="form-label">
                              Boat Registration
                              <span className="ct_required_star">*</span>
                            </label>
                            <select
                              id="boatId"
                              className="form-control ct_input ct_transparent_input ct_pointer_curser"
                              value={values?.boatId}
                              onBlur={handleBlur}
                              onChange={handleChange}
                            >
                              <option value="">Select boat</option>
                              {allBoats?.map((item) => (
                                <option key={item?.id} value={item?.id}>
                                  {item?.rego ?? ""} - {item?.name ?? ""}
                                </option>
                              ))}
                            </select>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="boatId"
                            />
                          </div>
                        </div> */}

                        <div className="col-lg-6">
                          <div className="form-group mb-3">
                            <label className="form-label">
                              Start Date
                              <span className="ct_required_star">*</span>
                            </label>
                            <input
                              id="date_scheduled_from"
                              type="date"
                              className="form-control ct_input ct_transparent_input"
                              value={values?.date_scheduled_from}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              onKeyDown={(e) => e.preventDefault()}
                              min={today}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="date_scheduled_from"
                            />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form-group mb-3">
                            <label className="form-label">
                              End Date
                              <span className="ct_required_star">*</span>
                            </label>
                            <input
                              id="date_scheduled_to"
                              type="date"
                              className="form-control ct_input ct_transparent_input"
                              value={values?.date_scheduled_to}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              onKeyDown={(e) => e.preventDefault()}
                              min={today}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="date_scheduled_to"
                            />
                          </div>
                        </div>

                        {values?.assignStaffId === "STAFF" && (
                          <div className="col-lg-12">
                            <div className="form-group mb-3">
                              <label className="form-label">
                                Scheduled Start Time
                                <span className="ct_required_star">*</span>
                              </label>
                              <DatePicker
                                value={values?.scheduled_start_time}
                                format="MM/DD/YYYY HH:mm:ss"
                                placeholder="Please select date time"
                                onChange={(time) =>
                                  setFieldValue(
                                    "scheduled_start_time",
                                    time?.format?.(),
                                  )
                                }
                                plugins={[<TimePicker position="bottom" />]}
                                inputClass="form-control ct_input ct_transparent_input"
                              />
                              <ErrorMessage
                                errors={errors}
                                touched={touched}
                                fieldName="scheduled_start_time"
                              />
                            </div>
                          </div>
                        )}

                        <div className="col-lg-12">
                          <div className="form-group">
                            <label className="form-label">
                              Maintenance Item Description
                              <span className="ct_required_star">*</span>
                            </label>
                            <textarea
                              id="description"
                              className="form-control ct_input ct_transparent_input"
                              rows="3"
                              value={values?.description}
                              onBlur={handleBlur}
                              onChange={handleChange}
                            ></textarea>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="description"
                            />
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className=" mt-3">
                            {/* <div>
                                 {console.log({ct_checkbox_cbx:values?.ct_checkbox_cbx})}
                              <input
                                type="checkbox"
                                id={`${modalId}_ct_checkbox_cbx`}
                                name="ct_checkbox_cbx"
                                className="form-check-input"
                                checked={Boolean(values?.ct_checkbox_cbx)}
                                onBlur={handleBlur}
                                onChange={(e) =>
                                  setFieldValue(
                                    "ct_checkbox_cbx",
                                    e.target.checked,
                                  )
                                }
                              />
                              <label
                                htmlFor={`${modalId}_ct_checkbox_cbx`}
                                className="ct_checkbox_cbx"
                              ></label>
                            </div> */}
                            <label
                              className="d-flex align-items-center"
                              style={{ width: "fit-content" }}
                              htmlFor={`${modalId}_ct_checkbox_cbx`}
                            >
                              <div class="form-check ct_custom_check2">
                                <input
                                  class="form-check-input ct_pointer_curser"
                                  type="checkbox"
                                  value=""
                                  id={`${modalId}_ct_checkbox_cbx`}
                                  name="ct_checkbox_cbx"
                                  checked={Boolean(values?.ct_checkbox_cbx)}
                                  onBlur={handleBlur}
                                  onChange={(e) =>
                                    setFieldValue(
                                      "ct_checkbox_cbx",
                                      e.target.checked,
                                    )
                                  }
                                />
                              </div>
                              <p className="mb-0 ct_pointer_curser">
                                Is Recurring
                              </p>
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex justify-content-end border-0 gap-2 ct_modal_footer ct_mt_30">
                        <button
                          type="button"
                          data-bs-dismiss="modal"
                          className="ct_outline_btn ct_outline_orange"
                          onClick={() => resetForm({ values: initialValues })}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="ct_border_radius_5 ct_h_40 ct_orange_btn px-5 text-center"
                          onClick={handleSubmit}
                          data-bs-dismiss={
                            values?.assignStaffId !== "" &&
                              Object?.keys(errors)?.length === 0
                              ? "modal"
                              : undefined
                          }
                        >
                          Assign
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignTechnicianModal;
